import { useNavigate } from 'react-router-dom';
import { MemberStatusConstants } from '../constants/MemberStatusConstants';

export const useImpersonation = () => {
  const navigate = useNavigate();

  const impersonate = async (memberId?: string, memberStatusId?: string): Promise<void> => {
    if (!memberId) {
      console.error('No member user ID found for impersonation');
      return;
    }

    try {
      // Open impersonation in new tab - ImpersonationRedirect will handle API call and redirect
      window.open(`/admin/impersonate/${memberId}`, '_blank');
    } catch (error) {
      console.error('Error opening impersonation tab', error);
    }
  };

  return { impersonate };
};
